export const languageCode = {
    ENGLISH: 'eng',
    SPANISH: 'es',
} as const;

export const languageLabels = {
    eng: 'English',
    es: 'Spanish',
} as const;

export type LanguageCodeType = (typeof languageCode)[keyof typeof languageCode];
